/**
 * @desc 列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.ProductCategroyModel>>;
export function request(
  body: defs.basics.ProductCategroyRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productCategroy/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
